import SidenavContainer from './sidenav/sidenav';
import HeaderContainer from './header/header';
import AuthHeaderContainer from './auth-header/auth-header';
import NavBarContainer from './navigation-bar/navigation-bar';
import MobileNavBar from './mobile-nav-bar/mobile-nav-bar';
import imgLazyLoader from './img-lazy-loader/directive';
import imgLazyLoaderLarge from './img-lazy-loader-large/directive';
import telFormat from './tel-format/tel-format';
import navlogin from './nav-login/nav-login';
import navMenu from './nav-menu/nav-menu';
import productPromo from './product-promo/product-promo';
import storePromo from './store-promo/store-promo';
import storeSelector from './store-selector/store-selector';
import thumbnailSlider from './thumbnail-slider/directive';
import appConstants from '../../constants';


export default angular.module('app.components', [])
  .component('sidenav', SidenavContainer)
  .component('header', HeaderContainer)
  .constant('APP', appConstants)
  .component('authHeader', AuthHeaderContainer)
  .component('navigationBar', NavBarContainer)
  .component('mobileNavigationbar', MobileNavBar)
  .directive('imgLazyLoader', imgLazyLoader)
  .directive('imgLazyLoaderLarge', imgLazyLoaderLarge)
  .component('navlogin', navlogin)
  .component('navMenu', navMenu)
  .component('productPromo', productPromo)
  .component('storePromo', storePromo)
  .component('storeSelector',storeSelector)
  .filter('telFormat', telFormat)
  .directive('thumbnailSlider',thumbnailSlider)
  ;



// WEBPACK FOOTER //
// ./src/app/components/main.js